import { createContext } from 'react';

/**
 * The auth context object, kept in its own module.
 *
 * Separated from AuthContext.jsx so that file exports only a component, which is
 * what React Fast Refresh requires to hot-reload a module without losing state.
 * A file mixing component and non-component exports forces a full reload on every
 * edit.
 */
export const AuthContext = createContext(null);
